export default {
      id: "icon-time-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-time",
      toString: function () {
        return this.url;
      }
    }